import { useGetVolumeByLocationQuery } from 'src/api/redux';
import { getSearchQueryParamsForAPI } from 'src/utils/url.helpers';
import { useNewProfile } from 'src/context/providers/ProfileProvider';

const useGetVolumeByLocation = (provider_id: string) => {
  const { savedSearchQueryParams } = useNewProfile();

  const queryParams = getSearchQueryParamsForAPI({
    cpt: savedSearchQueryParams.cpt?.map((item) => item.value),
    hcpcs: savedSearchQueryParams.hcpcs?.map((item) => item.value),
    icd: savedSearchQueryParams.icd?.map((item) => item.value),
    drg: savedSearchQueryParams.drg?.map((item) => item.value),
    icdp: savedSearchQueryParams.icdp?.map((item) => item.value),
  });

  const { data, error, isLoading, isFetching, refetch } =
    useGetVolumeByLocationQuery(
      { providerId: provider_id, queryParams },
      {
        skip: !provider_id,
      }
    );

  return {
    data,
    error,
    isLoading,
    isValidating: isFetching,
    mutate: refetch,
  };
};

export default useGetVolumeByLocation;
